import React from "react";
import { Link } from "react-router-dom";
import { getCutoutImage } from "../../utils/getCutoutImage";
import { BagIcon, EyeIcon } from "./ShopIcons";
import "../../styles/hlcShopSystem.css";

/**
 * Shared premium product card — same visual system as ShopScreen.jsx's
 * grid cards, reused by DiscountedProducts.js and ProductDetail.jsx's
 * "You may also like" section so every product listing on the site
 * looks like one design system.
 */
// Real-data-only badge: never invented — sourced directly from the
// product's own discount/topSelling/featured fields, in that priority
// order, so at most one badge shows per card.
function resolveBadge(product) {
  if (product.discount) return product.discount;
  if (product.topSelling) return "Best Seller";
  if (product.featured) return "Popular";
  return null;
}

export default function ProductCard({ product, cartItem, idx = 0, onAddToCart, onIncrement, onDecrement, onQuickView, onView }) {
  const image = getCutoutImage(product);
  const qty = cartItem?.quantity || 1;
  const badge = resolveBadge(product);

  return (
    <article className="hlc-prod-card" onClick={() => onView(product.id)}>
      {badge && (
        <span className="hlc-prod-card__badge">{badge}</span>
      )}
      <button
        type="button"
        className="hlc-prod-card__qv"
        aria-label={`Quick view ${product.name}`}
        onClick={(e) => {
          e.stopPropagation();
          onQuickView(product);
        }}
      >
        <EyeIcon />
      </button>

      <div className="hlc-prod-card__imgwrap">
        {image ? (
          <img src={image} alt={product.name} loading={idx < 8 ? "eager" : "lazy"} decoding="async" />
        ) : (
          <div className="hlc-prod-card__placeholder">No Image</div>
        )}
      </div>

      <div className="hlc-prod-card__body">
        <h3 className="hlc-prod-card__title" title={product.name}>{product.name}</h3>
        {product.category && <p className="hlc-prod-card__meta">{product.category}</p>}
        <div className="hlc-prod-card__price">
          {product.discountedPrice && <del>Rs {product.price}</del>}
          Rs {product.discountedPrice || product.price}
        </div>

        <div className="hlc-prod-card__cta-row">
          {!cartItem ? (
            <button
              type="button"
              className="hlc-prod-card__addcart"
              onClick={(e) => {
                e.stopPropagation();
                onAddToCart(product);
              }}
            >
              <BagIcon /> Add to Cart
            </button>
          ) : (
            <div className="hlc-prod-card__counter" onClick={(e) => e.stopPropagation()}>
              <button type="button" aria-label={`Decrease quantity of ${product.name}`} onClick={() => onDecrement(product.id)}>-</button>
              <span>{qty}</span>
              <button type="button" aria-label={`Increase quantity of ${product.name}`} onClick={() => onIncrement(product.id)}>+</button>
            </div>
          )}
          <Link
            to={`/product/${product.id}`}
            aria-label={`View ${product.name}`}
            className="hlc-prod-card__viewlink"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            View Product →
          </Link>
        </div>
      </div>
    </article>
  );
}
